import './styles.css';
import React from 'react';
import { Box, Container, Grid, IconButton, Typography } from '@material-ui/core';
import { CloseCircle } from 'iconsax-react';
import { BottomSheet } from 'react-spring-bottom-sheet';

const NewBottomSheet = (props) => {
	const { children, freeze, fullscreen, opening, setClose, noPadding, ...rest } = props;
	const [open, setOpen] = React.useState(opening);

	React.useEffect(() => {
		if (opening !== open) {
			setOpen(opening);
		}
	}, [opening]);

	const fullScreenSize = React.useMemo(() => {
		let result = false;
		if (fullscreen) {
			result = 3;
		}

		return result;
	}, [fullscreen]);

	function handleClose() {
		setOpen(false);
		setClose?.(false);
	}

	function handleClickOpen() {
		setOpen(rest.outside ? opening : true);
	}

	return (
		<>
			{rest?.action && (
				<Box onClick={handleClickOpen} style={{ zIndex: 1, ...rest?.innerActionStyle }}>
					{rest?.action}
				</Box>
			)}
			<BottomSheet
				open={open}
				onDismiss={freeze ? () => {} : handleClose}
				{...(fullscreen
					? {
							snapPoints: ({ maxHeight }) => [
								0.45 * maxHeight * fullScreenSize,
								0.83 * maxHeight * fullScreenSize,
							],
						}
					: {
							napPoints: ['100%'],
						})}
				defaultSnap={({ lastSnap, snapPoints }) => {
					lastSnap ?? Math.max(...snapPoints);
				}}
				style={{ zIndex: 3 }}
				blocking={true}
				{...rest}
				{...((rest?.header || rest?.iconClose || rest.actionElement) && {
					header: (
						<Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
							<Grid
								style={{ display: 'flex', justifyContent: 'flex-start' }}
								xs={rest.iconClose || rest.actionElement ? 6 : 12}
								item
							>
								{rest.header}
							</Grid>
							{(rest.iconClose || rest.actionElement) && (
								<Grid
									style={{ display: 'flex', justifyContent: 'flex-end' }}
									xs={rest.iconClose || rest.actionElement ? 6 : 12}
									item
								>
									{rest.iconClose ? (
										<IconButton onClick={handleClose}>
											<CloseCircle />
										</IconButton>
									) : (
										rest.actionElement
									)}
								</Grid>
							)}
						</Grid>
					),
				})}
			>
				<Container disableGutters={noPadding}>{children({ handleClose })}</Container>
			</BottomSheet>
		</>
	);
};

NewBottomSheet.defaultProps = {
	freeze: false,
	fullscreen: false, // fullscreen
	noPadding: true,
	expandOnContentDrag: true,
	opening: false,
	outside: true,
};

export default NewBottomSheet;
